import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 0 1rem;

    height: 2.938rem;
    border-bottom: 1px solid #e6e6e6;

    .header-divider {
        width: 1.125rem;
        margin: 0 1rem;
    }

    svg {
        position: absolute;
        right: 0;
        margin-right: 1rem;
    }

    .nav-logo {
        height: 0.845rem;
        width: 3.436rem;
    }

    .brand-logo {
        max-width: 6.178rem;
        max-height: 1.623rem;
    }

    @media (min-width: ${theme.breakpoints[0]}) {
        height: 3.688rem;
    }

    @media (min-width: ${theme.breakpoints[1]}) {
        .brand-logo {
            max-width: 7.313rem;
            max-height: 31.921rem;
        }

        .nav-logo {
            height: 1rem;
            width: 3.875rem;
        }
    }
`

export const HeaderContentContainer = styled.div`
    display: none;

    @media (min-width: ${theme.breakpoints[0]}) {
        display: flex;
        position: absolute;
        right: 0;
        align-items: center;
        margin-right: 1.5rem;

        .header-item {
            font-weight: 500;
            font-size: 0.875rem;
            line-height: 1rem;

            margin-right: 0.75rem;
            text-decoration: none;
        }

        button {
            height: 2rem;

            p {
                font-size: 14px;
                line-height: 16px;
            }
        }

        .vaccine-button {
            margin-right: 0.75rem;
        }
    }

    @media (min-width: ${theme.breakpoints[1]}) {
        margin-right: 1.5rem;

        .header-item {
            margin-right: 1.5rem;
        }

        .vaccine-button {
            margin-right: 1rem;
        }
    }
`
